import { getConfigValue } from '@jutro/config';
import { warning, info } from '@jutro/logger';
import { fetchTsmMessages } from './fetchTsmMessages';
export const tsmMessageLoader = async language => {
  const worksetUid = getConfigValue('JUTRO_TSM_WORKSET_UID', 'active');
  const stringVersion = getConfigValue('JUTRO_TSM_STRING_VERSION');
  const stringGroup = getConfigValue('JUTRO_TSM_STRING_GROUP');
  const jutroVersion = getConfigValue('JUTRO_CORE_STRING_VERSION');
  info("TSM enabled: Loading messages for \"".concat(language, "\" language, worksetUid: \"").concat(worksetUid, "\", string group: \"").concat(stringGroup, ":."));
  try {
    return await fetchTsmMessages(language, worksetUid, stringGroup, undefined, stringVersion, jutroVersion);
  } catch (err) {
    warning("TSM: Error loading translations. Details: ".concat(err));
    return {};
  }
};